import { render, staticRenderFns } from "./LabelNormalText.vue?vue&type=template&id=90e983ee&scoped=true&"
import script from "./LabelNormalText.vue?vue&type=script&lang=js&"
export * from "./LabelNormalText.vue?vue&type=script&lang=js&"
import style0 from "./LabelNormalText.vue?vue&type=style&index=0&id=90e983ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e983ee",
  null
  
)

export default component.exports